import { pageMeta } from '../seo.js';
import { Link } from 'react-router';
import ListView from '../components/ListView.jsx';
import { loadList } from '../data/list.js';
import { enhedsNummerOfCvr } from '../data/db.js';
import { eq } from '../data/sql.js';
import { thousands } from '../data/format.js';
import { companyPath } from '../data/relations.js';

const FIELDS = ['name', 'cvr', 'enhedsNummer', 'start', 'endDate', 'report'];

const COLUMNS = [
  { key: 'name', label: 'Name', render: (f) => <Link to={companyPath(f)}>{f.name}</Link> },
  { key: 'cvr', label: 'CVR', numeric: true },
  { key: 'period', label: 'Period', render: (f) => `${f.report?.period?.startDate ?? f.start ?? ''} – ${f.report?.period?.endDate ?? String(f.endDate ?? '').slice(0, 10)}` },
  { key: 'profitLoss', label: 'Resultat', numeric: true, render: (f) => thousands(f.report?.incomeStatement?.profitLoss) },
  { key: 'equity', label: 'Egenkapital', numeric: true, render: (f) => thousands(f.report?.balance?.liabilitiesAndEquity?.equity?.total) },
];

// cvrfinancial has no index on `cvr` since 2026-09-13; only (enhedsNummer, start).
// So a CVR number goes through the cvr collection first.
async function resolvePlan(plan) {
  if (plan.kind !== 'cvr') return plan;
  const enhedsNummer = await enhedsNummerOfCvr(plan.cvr);
  if (enhedsNummer === null) return { kind: 'error', message: `No company has the CVR number ${plan.cvr}.` };
  return { kind: 'where', where: eq('enhedsNummer', enhedsNummer) };
}

const LIST = { kind: 'financial', from: 'cvrfinancial', fields: FIELDS, resolvePlan };

// The server gets the rows before it sends the page (data/list.js).
export const loader = ({ request }) => loadList(new URL(request.url), LIST);

export const meta = () => pageMeta({
  title: 'Financials – CVR register',
  description: 'The annual reports (XBRL) of the Danish companies in the CVR register.',
  path: '/Financials',
});

export default function FinancialsPage() {
  return (
    <ListView
      title="Financials"
      subtitle="The annual reports (XBRL) of the companies"
      columns={COLUMNS}
      placeholder="CVR number or enhedsnummer"
      hint="The reports have no name index. Search for a CVR number, or open a company."
    />
  );
}
